var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLighning(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 12,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.665 12H2l.666-4.667H.332c-.587 0-.22-.5-.207-.52C.985 5.293 2.28 3.027 4.005 0h.667l-.667 4.667h2.34c.267 0 .414.126.267.44C3.979 9.7 2.665 12 2.665 12z",
    fill: "#E8560A"
  })));
}
export default SvgLighning;